<template>
  <transition name="fade-scale">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[100] bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4"
      @click="handleClose"
    >
      <div
        class="bg-white rounded-2xl p-6 max-w-md w-full animate-scale-in"
        @click.stop
      >
        <!-- Header -->
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <div class="w-8 h-8 bg-slate-100 rounded-full flex items-center justify-center">
              <IconThumbsDown class="w-4 h-4 text-slate-500" />
            </div>
            <h3 class="text-lg font-bold text-slate-900">内容反馈</h3>
          </div>
          <button
            @click="handleClose"
            class="p-2 hover:bg-slate-100 rounded-full transition-colors"
          >
            <IconX class="w-5 h-5 text-slate-400" />
          </button>
        </div>

        <p class="text-sm text-slate-500 mb-4">
          请告诉我们您不满意的原因，帮助我们改进内容质量。
        </p>

        <!-- Reasons -->
        <div class="space-y-2 mb-4">
          <button
            v-for="reason in REASONS"
            :key="reason.id"
            @click="selectedReason = reason.id"
            class="w-full text-left px-4 py-3 rounded-xl border transition-all"
            :class="selectedReason === reason.id
              ? 'border-amber-400 bg-amber-50 text-amber-700'
              : 'border-slate-200 hover:border-slate-300 text-slate-700'"
          >
            <div class="flex items-center gap-3">
              <div
                class="w-4 h-4 rounded-full border-2 flex items-center justify-center"
                :class="selectedReason === reason.id ? 'border-amber-400' : 'border-slate-300'"
              >
                <div v-if="selectedReason === reason.id" class="w-2 h-2 rounded-full bg-amber-400" />
              </div>
              <span class="text-sm font-medium">{{ reason.label }}</span>
            </div>
          </button>
        </div>

        <!-- Detail Input -->
        <div class="mb-6">
          <label class="text-sm font-medium text-slate-700 mb-2 block">
            补充说明（选填）
          </label>
          <textarea
            v-model="detail"
            placeholder="请详细描述您的问题..."
            class="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl text-sm resize-none focus:outline-none focus:border-amber-400 transition-colors"
            rows="3"
            maxlength="200"
          />
          <div class="text-right text-xs text-slate-400 mt-1">
            {{ detail.length }}/200
          </div>
        </div>

        <!-- Actions -->
        <div class="flex gap-3">
          <button
            @click="handleClose"
            class="flex-1 px-4 py-2.5 border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 transition-colors text-sm font-medium"
          >
            取消
          </button>
          <button
            @click="handleSubmit"
            :disabled="!selectedReason"
            class="flex-1 px-4 py-2.5 bg-amber-400 text-white rounded-xl hover:bg-amber-500 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            提交反馈
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { IconThumbsDown, IconX } from '../icons'

const REASONS = [
  { id: 'inaccurate', label: '内容不实' },
  { id: 'irrelevant', label: '与主题无关' },
  { id: 'outdated', label: '信息过时' },
  { id: 'other', label: '其他原因' },
]

export default {
  name: 'FeedbackModal',
  components: {
    IconThumbsDown,
    IconX
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      REASONS,
      selectedReason: '',
      detail: ''
    }
  },
  methods: {
    handleSubmit() {
      if (!this.selectedReason) return
      const reasonLabel = this.REASONS.find(r => r.id === this.selectedReason)?.label || this.selectedReason
      this.$emit('submit', reasonLabel, this.detail)
      this.reset()
      this.$emit('close')
    },
    handleClose() {
      this.reset()
      this.$emit('close')
    },
    reset() {
      this.selectedReason = ''
      this.detail = ''
    }
  }
}
</script>
